import React from 'react';

import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import FormikInput from 'src/components/formik/FormikInput';
import * as Yup from 'yup';


function WorkflowForm({ onSuccess }: { onSuccess: (res: any) => void }) {
  const fieldsConfig = [
    {
      name: 'name',
      component: () => (
        <FormikInput
          fullWidth
          label="Name"
          name="name"
          placeholder="e.g. Client onboarding"
        />
      ),
      validator: Yup.string().required(),
    },
    {
      name: 'description',
      component: () => (
        <FormikInput
          fullWidth
          label="Description"
          multiline
          rows={4}
          name="description"
        />
      ),
      validator: Yup.string().required(),
    },
  ];

  return (
    <CRUDConfigForm
      url="/automatic/workflows/"
      onSuccess={onSuccess}
      fieldsConfig={fieldsConfig}
      includeDeleteButton
    />
  );
}

export default WorkflowForm;
